module.exports = function getResource(label, vars = []) {
    const resources = {
        checkboxContentDefaultText: 'J’accepte les',
        checkboxContentDefaultLink: 'conditions'
    };
    return resources[label];
};
